import * as tradeInVehicleTypes from 'commons-vehicle/Vehicle/actions/tradeInVehicleActionTypes.js';
import purchaseMethodsTypes from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActionTypes.js';
import purchaseMethodsTypesV25 from 'commons-vehicle/PurchaseMethodsV25/actions/purchaseMethodsActionTypesV25.js';
import TradeInVehicleModel from 'commons-vehicle/Vehicle/models/TradeInVehicleModel.js';
import * as TradeInVehicleService from 'commons-vehicle/Vehicle/services/TradeInVehicleService/TradeInVehicleService.js';

export default function tradeInVehicleReducer(state = new TradeInVehicleModel(), action) {
    switch (action.type) {
        case purchaseMethodsTypes.LOAD_PURCHASE_METHODS_SUCCESS:
            return TradeInVehicleService.setTaxesFactor(state, action?.purchaseMethods || action?.purchaseMethodsV25);

        case tradeInVehicleTypes.SET_TRADE_IN_VEHICLE:
            return action.tradeInVehicle;

        case purchaseMethodsTypes.SET_TRADE_IN:
        case purchaseMethodsTypesV25.SET_TRADE_IN:
            return TradeInVehicleService.setTradeIn(state, action.tradeIn);

        case purchaseMethodsTypes.SET_LIEN:
        case purchaseMethodsTypesV25.SET_LIEN:
            return TradeInVehicleService.setLien(state, action.lien);

        case tradeInVehicleTypes.SET_TRADE_IN_TAX_CREDIT_DETAILS:
            return TradeInVehicleService.setTaxCreditDetails(state, action.tradeInTaxCreditDetails);

        default:
            return state;
    }
}
